'use strict';

/**
 * [init Initilizes cookie consent]
 * @param  {[string]} scope [A css selector]
 * @return {[undefined]}    [Nothing to return]
 */
export function init(scope) {
    $(scope).cookieConsent({
        cookieName: 'cookieConsent',
        btn: {
            accept: '.btn--primary'
        },
        transition: {
            show: {
                type: 'fadeIn',
                duration: 500
            },
            hide: {
                type: 'fadeOut',
                duration: 500
            }
        },
        consentType: 'explicit', // implied
        onAccepted: $.noop,
        onDeclined: $.noop,
        onCheck: $.noop
    });
}
